var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcScanWhiteLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 2C15.3076 2 14.881 2.42667 14.881 2.95238C14.881 3.4781 15.3076 3.90476 15.8333 3.90476H19.2485L11.3504 11.8028C10.9785 12.1747 10.9785 12.7776 11.3504 13.1496C11.5366 13.3357 11.78 13.4286 12.0238 13.4286C12.2676 13.4286 12.511 13.3357 12.6972 13.1496L20.5952 5.25149V8.66667C20.5952 9.19238 21.0219 9.61905 21.5476 9.61905C22.0733 9.61905 22.5 9.19238 22.5 8.66667V2.95238C22.5 2.42667 22.0733 2 21.5476 2H15.8333ZM5.35714 2.95238C3.78143 2.95238 2.5 4.23381 2.5 5.80952V19.1429C2.5 20.7186 3.78143 22 5.35714 22H18.6905C20.2662 22 21.5476 20.7186 21.5476 19.1429V13.4286C21.5476 12.9029 21.121 12.4762 20.5952 12.4762C20.0695 12.4762 19.6429 12.9029 19.6429 13.4286V19.1429C19.6429 19.6681 19.2157 20.0952 18.6905 20.0952H5.35714C4.8319 20.0952 4.40476 19.6681 4.40476 19.1429V5.80952C4.40476 5.28429 4.8319 4.85714 5.35714 4.85714H11.0714C11.5971 4.85714 12.0238 4.43048 12.0238 3.90476C12.0238 3.37905 11.5971 2.95238 11.0714 2.95238H5.35714Z",
    fill: "#0D1A16"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcScanWhiteLight);
export default __webpack_public_path__ + "static/media/ic_scan_whiteLight.1fc7af4e8480aae407343c98091a152c.svg";
export { ForwardRef as ReactComponent };